export enum MetricSystem {
    SI = 'SI',
    AU = 'AU'
}

export const MetricSystemDescription = {
    SI: 'Metric (SI)',
    AU: 'Imperial (AU)'
};
